import { useQuery } from "react-query";

import { peopleQueryKeys } from "./queryKeys";
import { IPerson } from "../../models/person/Person";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import useQSBuilder from "../../hooks/useQSBuilder";

export function usePersonEmails(personId: string, date?: string) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const emails = useQuery({
    queryKey: peopleQueryKeys.emails(personId, date),
    queryFn: () =>
      get(
        `/person/${personId}/emails${buildQs({ date })}`
      ) as unknown as IDefaultResponseWithData<IPerson>,
    refetchOnWindowFocus: false,
    enabled: !!personId,
  });

  return {
    emails,
  };
}
